export class NotificationTemplateLinkPreview {
  key?: string;
  link?: string;
}
